module.exports = __webpack_public_path__ + "media/images/logo-b23bce7396ebea1a9328f267bb228b59.png";